// Vercel Web Analytics scrubber. Several routes carry secrets in the URL —
// /verify?email=, the OAuth callback's ?code=/?state=, /payment/success?
// session_id=, and the invite token in /i/<token> — and Web Analytics records
// the full URL. Strip the query and hash off every event, collapse invite
// tokens to /i/:token, and drop the admin console entirely so operator
// traffic never pollutes the visitor numbers.
export const scrubAnalyticsEvent = (event) => {
  let url;
  try {
    url = new URL(event.url);
  } catch {
    return null;
  }

  if (url.pathname === '/admin' || url.pathname.startsWith('/admin/')) {
    return null;
  }

  url.pathname = url.pathname.replace(/^\/i\/[^/]+/i, '/i/:token');
  url.search = '';
  url.hash = '';
  return { ...event, url: url.toString() };
};
